
export class ChartOptionsBuilder {
  private _pipes: ((options: Highcharts.Options) => Highcharts.Options)[];
  constructor(pipes: ((options: Highcharts.Options) => Highcharts.Options)[]) {
    this._pipes = pipes;
  }

  public build(options: Highcharts.Options): Highcharts.Options {
    for (const pipe of this._pipes) {
      options = pipe(options);
    }
    return options;
  }
}